<template>
  <section class="md:mb-8 lg:mb-16">
    <div class="max-w-1440 mx-auto px-4 md:px-8 lg:px-16">
      <ProductsHeader />

      <!-- product list -->
      <items-header />
    </div>
    <items />
  </section>
</template>

<script>
import { watch } from 'vue'

import Items from '@/components/search/SearchItemsProducts.vue'
import ProductsHeader from '@/components/products/ProductsHeader.vue'
import ItemsHeader from '@/components/search/SearchItemsHeader.vue'

import router from '@/compositions/products/ProductRouter'
import searchQueryState from '@/compositions/search/SearchQuery'
import searchConfig from '@/compositions/search/SearchConfiguration'
import routerHelper from '@/compositions/search/SearchRouterHelper'
import searchFactory from '@/compositions/search/SearchFactory'

export default {
  router,
  components: {
    ProductsHeader,
    Items,
    ItemsHeader
  },
  props: {
    searchConfiguration: {
      type: Object,
      required: true
    },
    language: {
      type: String,
      required: true
    },
    baseUrl: {
      type: String,
      required: true
    }
  },
  setup(props) {
    searchConfig.searchConfigurationUse([props.searchConfiguration])
    const { getRouteData, updateRoute } = routerHelper.useRouterHelper(router, props.baseUrl)
    const routeData = getRouteData(router)
    routeData.language = props.language

    searchQueryState.searchQueryUse(routeData)
    const { loading } = searchFactory.useSearchResult()

    watch(
      () => [loading.value],
      () => {
        if (!loading.value) {
          updateRoute()
        }
      }
    )
    return {
      loading,
      routeData
    }
  }
}
</script>
